import styled from '@emotion/styled';

import { COLOR_BREADCRUMB_SEP } from './utils/variables';

export const BreadcrumbSep = styled.span`
  color: ${COLOR_BREADCRUMB_SEP};
`;
